const formationList = [

    {
        logo: 'assets/img/pages/resume/origamid.svg',
        title: 'Front-End | UX/UI Design',
        school: 'Origamid',
        content: 'Web Design Completo, Tipografia Avançada, UI Design Avançado, UX Design Heurísticas, Adobe XD, CSS Avançado , CSS Flexbox, CSS Grid Layout, JavaScript Completo ES6, React Completo, CSS com SASS, Vue.js Completo, Bootstrap 4, Automação Front End com NPM',
        startDate: '2020',
        endDate: '2021',
        link: '',
    },
    {
        logo: 'assets/img/pages/resume/html-dio.png',
        title: 'HTML Web Developer',
        school: 'Digital Innovation One',
        content: 'HTML5, CSS3, JavaScript, CSS Flexbox, Responsividade, Layouts, jQuery',
        startDate: 'Agosto/2020',
        endDate: 'Agosto/2020',
        link: 'https://drive.google.com/file/d/1LqThzc8ni0TRd3fxSYf2EBLmRWOWPSzS/view?usp=sharing',
    },
    {
        logo: 'assets/img/pages/resume/cloud-dio.png',
        title: 'Cloud Computing & Serverless',
        school: 'Digital Innovation One',
        content: 'Fundamentos da Computação em Nuvem, Fundamentos do Azure, Introdução aos Conceitos de Serverless e Azure Functions, Desenvolvimento de software com Azure Static Web Apps e GitHub Actions',
        startDate: 'Julho/2020',
        endDate: 'Julho/2020',
        link: 'https://drive.google.com/file/d/1S-12a5AHkttkwOeuyWacGU9yJBTyj7TY/view?usp=sharing',
    },
    {
        logo: 'assets/img/pages/resume/reactjs-dio.png',
        title: 'Desenvolvedor Front-End ReactJS',
        school: 'Digital Innovation One',
        content: 'Lógica de Programação, Git, GitHub, Arquitetura de Sistemas, HTML5, CSS3, Bootstrap, JavaScript ES6, ReactJS, TypeScript, Redux',
        startDate: 'Maio/2020',
        endDate: 'Junho/2020',
        link: 'https://drive.google.com/file/d/1X48G2DzlqjwTsD0rNFqTSBUkDa5kVxIg/view?usp=sharing',
    },

]

export default formationList;